hrd.datatable.dtSettings = function(doc, filterLabel) {
	let usingChromaFlow = dashboardInstance.usingChromaFlow();
	doc = doc || xlate('common.datatable.documents');
	filterLabel = (filterLabel) ? ("<div>" + filterLabel + ":_INPUT_</div>") : ("<div>" + xlate('common.datatable.filter') + ":_INPUT_</div>") ;
	return {
		bJQueryUI: true,
		bInfo: true,
		bProcessing: false,
		bPaginate: false,
		bSort: false,
		bFilter: false,
		bScrollCollapse: true,
		bServerSide: true,
		sDom:'rtiS',
		sScrollY: "100px",
		sAjaxSource: hrd.globals.datatableURI,
		/* classes */
		sInfoCls: 'ui-widget-content ui-corner-bottom',
		sFilterCls: 'ui-widget-content',
		sFilterInputCls: 'editable-data ui-widget-content ui-corner-all filter-field ignore-for-fhs',
		sFilterInputAdditionalCls: '',
		sScrollWrapperCls: 'ui-widget-content',

		/* end classes */
		oLanguage : {
			  "sSearch": filterLabel,
			  "sZeroRecords": xlate('common.datatable.zeroRecords'),
			  "sEmptyTable": xlate('common.datatable.emptyTable'),
			  "sInfo": xlate('common.datatable.info', {doc: doc}),
			  "sInfoFiltered": xlate('common.datatable.infoFiltered', {doc: doc}),
			  "sInfoEmpty": xlate('common.datatable.infoEmpty'),
			  "sMissingProviderMessage": xlate('common.datatable.missingProviderMessage')
		},
		oScroller: {
			"loadingIndicator": false,
			"displayBuffer": 5,
			"serverWait": 100,
			"rowHeight": usingChromaFlow ? 28 : 24,
			"trace": false
		},
		/**
		 * Used to register once a generic 'serverParam' callback with dynamic pageSize computation.
		 * As prerequisite the container must have the the final 'dimensions' in order to compute how many rows will be visible in the table viewport.
		 * TODO: a refactoring is needed in order to have some computation only once (and not only for tables with scroller, but all type of tables). Moreover
		 * pay attention to 'resize', because during resize, table viewport size can change.
		 */
		fnPreDrawCallback: function(oSettings) {
			let sTableId = oSettings.nTable.id;
			if(!oSettings.oInit.bServerParamFnAlreadyRegistered){
				oSettings.oInit.bServerParamFnAlreadyRegistered = true;
				let iPageSize = -1; // se non paginato, allora dammele tutte.
				if(oSettings.oScroller && oSettings.oScroller.s) {
					let logging = false;
					var data = oSettings.oScroller.s;
					//// just once - perhaps some code in drawcallback can be moved here and done just once??
					/* used to compute table height */
					var oInit = oSettings.oInit;
					var scrollHeight = 0;
					
					if(oInit.sContainerId){
						var $dtCaption = $(`#${sTableId}_caption`);
						var $dtFilter = $(`#${sTableId}_filter`);
						var $dtScroll = $(`#${sTableId}_wrapper .dataTables_scroll`);
						var $dtInfo = $(`#${sTableId}_info`);

						$dtScroll.addClass(oInit.sScrollWrapperCls);
						$dtInfo.addClass(oInit.sInfoCls).width($dtScroll.width() +'px');

						var $container = $(oInit.sContainerId);
						var $dtHead = $(oSettings.nScrollHead);
						var $dtFoot = $(oSettings.nScrollFoot);
						var extraHeight = 0;
						if(oInit.sExtraToolbarId){
							var $extraToolbar = $(oInit.sExtraToolbarId);
							extraHeight = $extraToolbar.outerHeight(true);
						}
						var infoContrib = $dtInfo.is(':visible') ? $dtInfo.outerHeight(true) : 0,
							headContrib = ($dtHead.is(':visible') && oInit.bHideHead != true) ? $dtHead.outerHeight(true) : 0,
							footContrib = $dtFoot.is(':visible') ? $dtFoot.outerHeight(true) : 0,
							filterContrib = $dtFilter.is(':visible') ? $dtFilter.outerHeight(true) : 0,
							captionContrib = $dtCaption.is(':visible') ? $dtCaption.outerHeight(true) : 0;
						// log useful for debugging purpose
						if(logging) {
							console.log(`Table:\t${sTableId}
                                \tinfoContrib: ${infoContrib}
                                \theadContrib: ${headContrib}
                                \tfootContrib: ${footContrib}
                                \tfilterContrib: ${filterContrib}
                                \tcaptionContrib: ${captionContrib}
                                \textraHeight: ${extraHeight}
                                \n\n`.replaceAll('  ', '')
                            );
						}
						var scrollY = $container.height() - ($dtScroll.outerHeight(true) - $dtScroll.height()) - infoContrib - headContrib - footContrib - filterContrib - captionContrib - extraHeight;
						scrollHeight = scrollY;
					} else {
						scrollHeight = hrd.utils.widthAsNumber(oInit.sScrollY);
					}
					// need to recompute 
					let rowHeight = hrd.datatable.computeRowHeight(oSettings, data.rowHeight);
					let rows = parseInt(scrollHeight / rowHeight, 10) + 1;
					iPageSize = rows * data.displayBuffer;
					oSettings.oScroller.s.rowHeight = rowHeight; // aggiorno la rowHeight con quella effettivamente in uso dato il 'layoutSize'
					oSettings.oScroller.s.iPageSize = iPageSize; // aggiungo la page size effettivamente usata. potrebbe essere diversa dalla 'viewportRows'
					// log useful for debugging purpose
					if(logging) {
						console.log(`Table:\t${sTableId}
                        \tdisplayBuffer: ${data.displayBuffer}
                        \trowHeight: ${rowHeight}
                        \trows: ${rows}
                        \tpageSize: ${iPageSize}
                        \tscrollHeight: ${scrollHeight}
                        \trows effective: ${scrollHeight / rowHeight}
                        \n\n`.replaceAll('  ', ''), oSettings.oScroller);
					}
					if(iPageSize <= 0) {
						iPageSize = oInit.iPageSizeFallback != undefined ? oInit.iPageSizeFallback : 50;
					}
				}
				/* registering serverParam callback */
				oSettings.aoServerParams.push({ "fn": function(aoData){
					aoData.push({"name": "iPageSize", "value": this.pageSize});
				}.bind({pageSize: iPageSize}), "sName": "customServerParam" });
			}
			/* used to invoke, if present, a custom 'fnCustomPreDrawCallback' when defined in initParams */
			if(typeof oSettings.oInit.fnCustomPreDrawCallback == 'function'){
				oSettings.oInit.fnCustomPreDrawCallback(oSettings);
			}

			/* hack for chroma-flow in order to support scrolling pagination */
			const $scrollerBlock = $(oSettings.nTable).siblings('div').first();
			//const $scrollHead = $(oSettings.nScrollHead);
			if($scrollerBlock.exists() && !$scrollerBlock.data('reset') ) {
				$scrollerBlock.attr('data-reset', 'exclude');
			}
		},
		fnDrawCallback: function( oSettings ) {
			hrd.datatable.drawCallback(oSettings);
		}
	};
}

hrd.datatable.computeRowHeight = function(oSettings, rowHeight) {
	if(dashboardInstance.usingChromaFlow()) {
		const paddingCellHeight = 2; // every cell in chroma-flow has a fixed padding of 1px
		return dashboardInstance.adaptSize(rowHeight, {constantSize: paddingCellHeight});
	} else {
		let $table = $(oSettings.oScroller.dom.table);
		let verticalSpacing = $table.borderSpacingVertical();
		return rowHeight + verticalSpacing;
	}
}

hrd.datatable.resize = function(redrawTables){
	if(redrawTables){
		var tables = $.fn.dataTable.fnTables(true);
		for ( var j = 0; j < tables.length; j++) {
			var oSettings = $(tables[j]).dataTable().fnSettings();
			oSettings.bResizing = true;
			oSettings.oInit.bServerParamFnAlreadyRegistered = false; // needed in order to recompute, if needed, the scroller pageSize
			{
				// NEEDED OTHERWISE pagesize is added more than once
				var found = false;
				var position = -1;
				for (var i = 0; i < oSettings.aoServerParams.length && !found; i++) {
					var item = oSettings.aoServerParams[i];
					if(item.sName === "customServerParam"){
						found = true;
						position = i;
					}
				}
				oSettings.aoServerParams.splice(position, 1);
			}
			oSettings.oInit.fnPreDrawCallback(oSettings);
			oSettings.oInit.fnDrawCallback(oSettings);
			delete oSettings.bResizing;
		}
	}
};

hrd.datatable.rowBehavior = function(nTable, nRow, aData, iDisplayIndex, iDisplayIndexFull, fnClick, fnDblClick, fnChange, fnOver, fnOut, fnCellOver, fnCellOut) {
	var hasFnClick = !!fnClick
	var hasFnDblClick = !!fnDblClick
	var hasFnChange = !!fnChange
	var clickTimeout = (hasFnDblClick) ? 400 : 50;
	fnClick = fnClick || $.noop;
	fnDblClick = fnDblClick || $.noop;
	fnChange = fnChange || $.noop;

	var fnMouseOver = (event) => {
		let skipFocus = false;
		if(typeof fnOver === 'function'){
			skipFocus = !!fnOver(nRow, aData, iDisplayIndex, iDisplayIndexFull, event);
		}
		if(!skipFocus) {
			hrd.datatable.addRowClass($(event.currentTarget), 'ui-state-focus');
		} 
	};
	var fnMouseOut = (event) => {
		let skipUnfocus = false;
		if(typeof fnOut === 'function') {
			skipUnfocus = !! fnOut(nRow, aData, iDisplayIndex, iDisplayIndexFull, event);
		}
		if(!skipUnfocus) {
			hrd.datatable.removeRowClass($(event.currentTarget), 'ui-state-focus');
		}
	};
	
	var fnMouseCellOver = (event) => {
		if(typeof fnCellOver === 'function') {
			let td = event.currentTarget
			let $td = $(td);
			let tableInstance = $(nTable).dataTable();
			let coords = tableInstance.fnGetPosition(td);
			let iRow = coords[0];
			let iCol = coords[1];
			let columnName = tableInstance.fnGetColumnNameByIndex(iCol);
			fnCellOver($td, columnName, aData, iRow, iCol, event);
		}
	};
	var fnMouseCellOut = (event) => {
		if(typeof fnCellOut === 'function') {
			let td = event.currentTarget
			let $td = $(td);
			let tableInstance = $(nTable).dataTable();
			let coords = tableInstance.fnGetPosition(td);
			let iRow = coords[0];
			let iCol = coords[1];
			let columnName = tableInstance.fnGetColumnNameByIndex(iCol);
			fnCellOut($td, columnName, aData, iRow, iCol, event);
		}
	};	

	let rowclick;
	let oSettings = $(nTable).dataTable().fnSettings();
	let offset = oSettings._iDisplayStart;
	$(nRow).attr('row-index', iDisplayIndexFull + offset)
		.data('row-index', iDisplayIndexFull + offset)
		.off('.rowBehavior')
		.on('mouseenter.rowBehavior', fnMouseOver)
		.on('mouseleave.rowBehavior', fnMouseOut);

	$(nRow).find('td')
		.off('.rowBehavior')
		.on('mouseenter.rowBehavior', fnMouseCellOver)
		.on('mouseleave.rowBehavior', fnMouseCellOut);

	if(hasFnClick){
		$(nRow).off('click.rowBehavior').on('click.rowBehavior', function(event){
			let $row = $(nRow);
			var $radio = $row.find('input[type="radio"]');
			var radioInfo = $radio.data('info');
			var reclickable = (radioInfo && radioInfo.reclickable) || false;
			let toggleable = (radioInfo && radioInfo.toggleable) || false;
			var forceClick = $row.data('force-click') || false;
			// remove forceClick
			$row.removeData('force-click');
			//
			if($radio.exists() && ((!$radio.is(':checked')) || forceClick || reclickable || (event.target.type == "radio"))) {
				let isAlreadyChecked = $radio.is(':checked');
				let checkedValue = (toggleable && isAlreadyChecked) ? false : true;
				$radio.prop("checked", checkedValue); // force checking the radio, label will be 'deactivated' with preventDefault
				var ignoreCallback = $row.data('ignore-callback') || false;
				rowclick = true;
				$.timeout(clickTimeout, nRow, aData, iDisplayIndex, iDisplayIndexFull, fnClick)
					.then(function(nRow, aData, iDisplayIndex, iDisplayIndexFull, fnClick){
						var promise;
						if(rowclick){
							if(!ignoreCallback){
								promise = $.when(fnClick(nRow, aData, iDisplayIndex, iDisplayIndexFull, checkedValue)); // depends on fnClick returned object, if promise or not
							} else {
								$row.removeData('ignore-callback');
								promise = $.when();
							}
							rowclick = false;
						} else {
							promise = $.when();
						}
						return promise;
					})
					.then(data => {
						if(data && (data.stop === true || data.preventDefault === true)){
							var prevRowId = $(nTable).data('active-row');
							if(prevRowId != undefined){
								var $prevRadio = $(nTable).find('input[type="radio"][value="' + prevRowId + '"]');
								$prevRadio.prop("checked", true);
							} else {
								// nothing was selected before. need to uncheck manually current radio;
								$radio.prop("checked", false);
							}
						} else {
							hrd.datatable.removeRowClass($row, 'ui-state-active', true);
							if(checkedValue) {
								hrd.datatable.addRowClass($row, 'ui-state-active', true);
							}
						}
					})
					.fail(function(){
						hrd.dashboard.msgBox({
							title: xlate('common.dialog.warning.title.msg'),
							text: xlate('common.dialog.no.connection.error.msg'),
							type: 'OK'
						});
					});
			}
			if(event.target.tagName === 'LABEL'){
				event.preventDefault(); //14/02/19 uncommented again, because changed implementation // #2289: commented because otherwise the hidden radio button is not 'checked'
			}
		})
	}
	if(hasFnDblClick){
		$(nRow).off('dblclick.rowBehavior').on('dblclick.rowBehavior', function(event){
			rowclick = false;
			hrd.datatable.removeRowClass($(nRow), 'ui-state-active', true);
			hrd.datatable.addRowClass($(nRow), 'ui-state-active', true);
			fnDblClick(nRow, aData, iDisplayIndex, iDisplayIndexFull);
		});
	}
	if(hasFnChange){
		$('input[type="checkbox"]', nRow)
			.filter((_, inp)  => (!$(inp).hasClass('generic-checkbox')))
			.off('change.rowBehavior')
			.on('change.rowBehavior', function(event){
				var $checkbox = $(this);
				fnChange(nRow, aData, iDisplayIndex, iDisplayIndexFull, $checkbox.prop('checked'), $checkbox.val(), event);
			});
	}
	// adding code for ellipsis, should be done in every rowCallback. add a new 'feature'//
	hrd.datatable.ellipsis(nTable, nRow, aData, iDisplayIndex, iDisplayIndexFull);
};

hrd.datatable.addRowClass = function($row, className, activate){
	$row.addClass('tr-' + className);
	$row.find('td:not(.no-focus)').addClass(className);
	if ($row.has('td[rowspan]').length == 0){
		$row.prevAll('tr:has(td[rowspan]):first').find('td[rowspan]').addClass(className);
	}
	if(activate){
		 $row.closest('table').data('active-row', $row.attr('id'));
	}
};

hrd.datatable.removeRowClass = function($row, className, full){
	var $table = $row.closest('table');
	$('tr', $table).removeClass('tr-' + className);
	if(full){
		$('td.' + className, $table).removeClass(className);
	} else {
		$row.find('td:not(.no-focus)').removeClass(className);
		$row.prevAll('tr:has(td[rowspan]):first').find('td[rowspan]').removeClass(className);
	}
};

/**
 * Adding ellipsis to needed cells
 */
hrd.datatable.ellipsis = function(nTable, nRow, aData, iDisplayIndex, iDisplayIndexFull) {
	/*
	const chromaSetCellWidth = ($item, $label, width) => {
		if($label.exists()) {
			$label.prop('style').setProperty('--width', `${width}px`);
		}

		if($item.exists()) {
			$item.prop('style').setProperty('--width', `${width}px`);
		}
	}
	*/

	// sarebbe da aggiungere 6 per i bordi e padding, per ora bypasso. non calcolabile in chrome con '$(this).mbpWidth() + $label.mbpWidth()'
	var $table = $(nTable);
	const usingChromaFlow = $table.usingChromaFlow();
	var ellipsisClass = $table.data('ellipsis-class') || '';
	var tooltipAsHtmlClass = !!$table.data('tooltip-as-html');
	var isTable2x = $table.hasClass('table-2x');
	var EXTRA_MARGIN_BORDER_PADDING_WIDTH = 6;
	var activeMetricClass = isTable2x ? 'dataTables_active_cell_length_evaluator_2x' : 'dataTables_active_cell_length_evaluator';
	var column, headerWidth, $label, $item, actualWidth, oSettings, computedWidth;
	oSettings = $table.dataTable().fnSettings();

	$('td', nRow).each(function (index, item) {
		$item = $(item);
		if(!$item.hasClass('without-ellipsis')){
			column = oSettings.aoColumns[index];
			if(column && column.nTh){
				/* uso 'sWidthOrig' al posto di 'sWidth': contiene le informazioni passate non quelle calcolate */
				$label = $item.find('label.table_cell_content');
				let thOuterWidth = $(column.nTh).outerWidth(true);
				headerWidth = column.sWidthOrig != undefined ? hrd.utils.widthAsNumber(column.sWidthOrig) : thOuterWidth;
				
				//store 'sWidthOrig' again, in order to support nulls
				column.sWidthOrig = `${headerWidth}px`;

				headerWidth = Math.min(headerWidth,  thOuterWidth);
				/* GB: 03/08/2020: add ellipsis class and effective widths to some cells */
				computedWidth = $label.textMetrics(activeMetricClass).width;
				if(computedWidth > headerWidth){
					//console.log(`"${$label.text()}"`, column.sWidthOrig, headerWidth, thOuterWidth, computedWidth);

					if(!usingChromaFlow) {
						actualWidth = headerWidth - EXTRA_MARGIN_BORDER_PADDING_WIDTH;
						$label.css({
							'width': actualWidth + 'px',
							'max-width': actualWidth + 'px',
							'min-width': actualWidth + 'px',
						});
					}

					$label.addClass('ellipsis').attr("title", tooltipAsHtmlClass ? $label.html() : $label.text()).tooltip({
						tooltipClass: ellipsisClass
					});
				}
			}
		}

		if(usingChromaFlow) {
			let promise = oSettings.pResizePromise || $.timeout(0);
			promise
				.then(() => {
					const col = oSettings.aoColumns[index];
					const $td = $(item);
					const $th = $(col.nTh);
					const $l = $td.find('label.table_cell_content');
					const sWidth = parseInt(col.sWidth);
					const iWidth = parseInt($th.width());
					// when resizig use the header width, otherwise use the min value between header width and sWidth
					let thWidth = (oSettings.bResizing) ? iWidth : Math.min(sWidth, iWidth);
					const tdLabelExpectedWidth = $l.textMetrics(activeMetricClass).width;

					if(thWidth && $td.exists()) {
						const index = $th.index();
						const $bodyTh = $table.find('thead tr[role="row"] th').eq(index);
						const $targets = $td
							.add($bodyTh)
							.add($th);
							
						//force "scrollbar-cell" to have 6px as width
						if($td.hasClass('scrollbar-cell')) {
							thWidth = 6;
						}
						$targets.each((i, target) => {
							const targetStyle = $(target).get(0).style;

							targetStyle.setProperty('--width', `${thWidth}px`);
							targetStyle.setProperty('--min-width', `${thWidth}px`);
							targetStyle.setProperty('--max-width', `${thWidth}px`);
						});
					}

					if(!$td.is('.without-ellipsis') && tdLabelExpectedWidth > thWidth) {
						$l.addClass('ellipsis').attr("title", tooltipAsHtmlClass ? $l.html() : $l.text()).tooltip({
							tooltipClass: ellipsisClass
						});
					} else {
						$l
							.removeClass('ellipsis')
							.attr('title', '');
					}
				});
		}
	});
};

/**
 * Facility for colouring the background of a row with a given colour.
 * Moreover the foreground colour will be computed in order to make it visible on that background
 * @param nTable
 * @param nRow
 * @param backgroundColor
 * @Deprecated
 */
hrd.datatable.colorizeRow = function(nTable, nRow, bgColor) {
	var fgColor = $.colorHelper().computeTextColor(bgColor);
	var focusColor = $.colorHelper().darken(bgColor, 15);
	var fgFocusColor = $.colorHelper().computeTextColor(focusColor);
	var normalStyle = {backgroundColor: bgColor, color: fgColor, borderColor: bgColor};
	var focusStyle = {backgroundColor: focusColor, color: fgFocusColor, borderColor: focusColor};
	$('td:not(.no-focus)', nRow).each((i, cell) => {
		$(cell).addClass('custom-color').css(normalStyle);
	});
	$(nRow).off('.cr')
	.on('mouseover.cr', (evt) => {
		$('td:not(.no-focus)', evt.currentTarget).each((i, cell) => {
			$(cell).css(focusStyle);
		});
	})
	.on('mouseout.cr', (evt) => {
		$('td:not(.no-focus)', evt.currentTarget).each((i, cell) => {
			$(cell).css(normalStyle);
		});
	});
};

/**
 * @Deprecated
 */
hrd.datatable.changeCheckboxCallback = function(nTable, triggerEventOrFunction){
	var triggerEvent, fnCall;
	if(typeof triggerEventOrFunction == 'function'){
		fnCall = triggerEventOrFunction;
		return function(nRow, aData, iDisplayIndex, iDisplayIndexFull, isChecked){
			fnCall.call($(nTable).dataTable(), isChecked);
		};
	} else {
		triggerEvent = triggerEventOrFunction;
		return function(nRow, aData, iDisplayIndex, iDisplayIndexFull, isChecked){
			var options= {indexes:[]};
			$('input[type="checkbox"]:checked', nTable).each(function(){
				options.indexes.push($(this).val());
			});
			$.emit(triggerEvent, options);
		};
	}
};

/**
 * @Deprecated
 */
hrd.datatable.changeAllCheckbox = function(checked, nTable, triggerEvent, fnCallBack){
	var options= {indexes:[]};
	$('input[type="checkbox"]', nTable).prop('checked', checked);
	$('input[type="checkbox"]:checked', nTable).each(function(){
		options.indexes.push($(this).val());
	});
	if(typeof fnCallBack == 'function'){
		fnCallBack.call(undefined, options, nTable);
	}
	if(triggerEvent != undefined){
		$.emit(triggerEvent, options);
	}
};

hrd.datatable.drawCallback = function(oSettings){
	var oInit = oSettings.oInit;
	var sTableId = oSettings.nTable.id;

	if(oSettings.jCachedData && oSettings.jCachedData._status_ === 'MISSING_PROVIDER'){
		$('.dataTables_empty', '#' + sTableId).html(oSettings.oLanguage.sMissingProviderMessage).css({
			'color': 'red',
			'font-size': 'larger',
			'font-weight': 'bold'
		});
	}

	if(oInit.bHideHead === true){
		$(oSettings.nScrollHead).hide();
	}

	var $dtCaption = $('#' + sTableId + '_caption');
	var $dtFilter = $('#' + sTableId + '_filter');
	var $dtInputFilter = $('#' + sTableId + '_filter input');
	var $dtScroll = $('#' + sTableId + '_wrapper .dataTables_scroll');
	var isTableInsideDialog = (oSettings.nTable.closest('.ui-dialog') != null);
	if(isTableInsideDialog){
		/* if table is inside dialog and scrollbody is positioned,
		 * a zindex must be set in order to have an higher value than
		 * dialog overlay (normally higher than 1000)
		 */
		var $dtScrollBody = $(oSettings.nTable.closest('.dataTables_scrollBody'));
		var overlayZIndex = $('.ui-widget-overlay').zIndex();
		$dtScrollBody.zIndex(overlayZIndex + 50);
	}
	var $dtInfo = $('#' + sTableId + '_info');
	if(!$dtInfo.exists()){
		$dtScroll.addClass('no-info');
	}
	$dtInputFilter.addClass(oInit.sFilterInputCls);
	$dtInputFilter.addClass(oInit.sFilterInputAdditionalCls);
	$dtInputFilter.off('focus.filter').on('focus.filter', function(){
		$(this).select();
	})
	$dtScroll.addClass(oInit.sScrollWrapperCls);
	$dtFilter.addClass(oInit.sFilterCls);
	if($dtScroll.width() > 0){
		$dtFilter.width($dtScroll.width() +'px');
	}
	$dtInfo.addClass(oInit.sInfoCls).width($dtScroll.width() +'px');

	/* scrollbar size */
	var $dtHead = $(oSettings.nScrollHead);
	var $dtFoot = $(oSettings.nScrollFoot);
	if($.getScrollbarWidth() == 0){
		// scrollbars have no size
		$dtHead.addClass('collapsed-scrollbar');
		$dtFoot.addClass('collapsed-scrollbar');
	}

	/* used to force table height */
	var scrollHeight = "0";
	if(oInit.sContainerId){
		var $container = $(oInit.sContainerId);
		var usedHeight = $(oSettings.nTable.parentNode).data('used-height');
		if(!$container.is(':visible') && usedHeight != undefined){
			scrollHeight = usedHeight ;
		} else {
			var extraHeight = 0;
			if(oInit.sExtraToolbarId){
				var $extraToolbar = $(oInit.sExtraToolbarId);
				extraHeight = $extraToolbar.outerHeight(true);
			}
			var infoContrib = $dtInfo.is(':visible') ? $dtInfo.outerHeight(true) : 0,
				headContrib = $dtHead.is(':visible') ? $dtHead.outerHeight(true) : 0,
				footContrib = $dtFoot.is(':visible') ? $dtFoot.outerHeight(true) : 0,
				filterContrib = $dtFilter.is(':visible') ? $dtFilter.outerHeight(true) : 0,
				captionContrib = $dtCaption.is(':visible') ? $dtCaption.outerHeight(true) : 0;

			var scrollY = $container.height()- ($dtScroll.outerHeight(true) - $dtScroll.height()) - infoContrib - headContrib - footContrib - filterContrib - captionContrib - extraHeight;
			scrollHeight = scrollY + "px";
			let logging = false;
			if(logging) {
				console.log(`Table:\t${sTableId}
                \tinfoContrib: ${infoContrib}
                \theadContrib: ${headContrib}
                \tfootContrib: ${footContrib}
                \tfilterContrib: ${filterContrib}
                \tcaptionContrib: ${captionContrib}
                \tcontainerContrib: ${$container.height()}
                \tscrollY: ${scrollY}
                \n\n`.replaceAll('  ', ''));
			}
		}
	} else {
		scrollHeight = oInit.sScrollY;
	}

	/* added for tables without "scroller" like workers */
	if(oSettings.oScroller == undefined){
		oSettings.oScroller = {
			"dom": {
				"scroller": oSettings.nTable.parentNode,
			},
			"fnScrollToRow": function ( iRow, bAnimate ){
				var row = oSettings.oInstance.fnGetNodes(iRow);
				var px = iRow * ($(row).height() + 1); // 1: due to cellspacing
				if ( typeof bAnimate == 'undefined' || bAnimate ){
					$(this.dom.scroller)
					.stop()
					.animate( {
						"scrollTop": px
					}, 300);
				} else {
					$(this.dom.scroller).scrollTop( px );
				}
			}
		};
		$(oSettings.oInstance).dataTable().fnApplyWaiting();
	} else {
		/* registering waiting for scrollers */
		$(oSettings.oInstance).dataTable().fnApplyWaiting();
	}
	/* needed for computing exactly the scroller dom height */
	if(oSettings.oScroller.fnMeasure){
		setTimeout(function(){
			oSettings.oScroller.fnMeasure(false);
			// Need to recalculate "iPageSize" if not coherent with the measures
			let iDisplayLength = oSettings.oScroller.s.dt._iDisplayLength;
			let iPageSize = oSettings.oScroller.s.iPageSize;
			if(iDisplayLength != iPageSize) {
				let customServerParam = oSettings.aoServerParams.find(p => p.sName === 'customServerParam');
				if(customServerParam != undefined){
					oSettings.oScroller.s.iPageSize = iDisplayLength; // store the correct value
					customServerParam.fn = function(aoData){
						aoData.push({"name": "iPageSize", "value": this.pageSize});
					}.bind({pageSize: iDisplayLength});
				}
			}
		}, 0);
	}

	/* used for adding table-size in header: this can happen only if sDom has not 'i' inside and the table is used inside a panel and a specific settings is added */
	if(oSettings.sDom.indexOf('i') == -1 && oInit.bInfoInHeader === true){
		var panelTitleText = $(oSettings.nTable).closest('.dashlet-panel').find('.dashlet-header .ui-panel-title-text');
		if(panelTitleText.exists()){
			var tableSizeBox = panelTitleText.find('.table-size-box');
			if(!tableSizeBox.exists()){
				tableSizeBox = $('<span class="table-size-box"></span>');
				panelTitleText.append(tableSizeBox);
			}
			tableSizeBox.text('(' + oSettings._iRecordsTotal + ')');
		}
	}

	$(oSettings.nTable.parentNode).height(scrollHeight).data('used-height', scrollHeight);

	/* registering keep selection */
	if(oInit.bKeepSelection){
		hrd.datatable.activateActiveRow(oSettings);
	}

	if(oInit.fnCustomDrawCallback){
		oInit.fnCustomDrawCallback(oSettings);
	}

};

hrd.datatable.getActiveRowId = function(tableId){
	return $(tableId).data('active-row');
};

hrd.datatable.clearRowActive = function(tableId){
	 $(tableId).removeData('active-row');
};

hrd.datatable.makeRowActive = function(tableId, rowId){
	var $row = this.getRowById(rowId, tableId);
	if($row.exists()){
		$(tableId).data('active-row', $row.attr('id'));
		// make radio selected if available
		var $radio = $row.find('input[type="radio"]');
		if($radio.exists()){
			$radio.prop("checked", true);
		}
	}
};

hrd.datatable.activateActiveRow = function(oSettings){
	let $table = $(oSettings.oInstance);
	var activeIndex = $table.data('active-row');
	var $row = $table.find(`tr[id="${activeIndex}"]`);
	if($row.exists()){
		hrd.datatable.addRowClass($row, 'ui-state-active');
		$radio = $row.find('input[type="radio"]');
		if($radio.exists()){
			$radio.prop('checked', true);
		}
	}
};

hrd.datatable.deactivateActiveRow = function(oSettings){
	let $table = $(oSettings.oInstance);
	var activeIndex = $table.data('active-row');
	var $row = $table.find(`tr[id="${activeIndex}"]`);
	if($row.exists()){
		hrd.datatable.removeRowClass($row, 'ui-state-active');
		$radio = $row.find('input[type="radio"]');
		if($radio.exists()){
			$radio.prop('checked', false);
		}
	}
};

/**
 * Method that will filter the table programmatically
 *
 */
hrd.datatable.filter = function(tableId, filterText){
	$(tableId).dataTable().fnFilter(filterText);
};

/**
 * Method that will clear the filter table field
 *
 */
hrd.datatable.clearFilters = function(tableId, redraw){
	$(tableId).dataTable().fnFilterClear(true, redraw);
};

hrd.datatable.selectAdapter = function(data, selected){
	var list = [];
	if(data){
		for(var i = 0; i < data.aaData.length; i++) {
			var row = data.aaData[i];
			var item = {value: row.id, label: row.name};
			if(row.id == selected){
				item.selected = true;
			}
			list.push(item);
		}
	}
	return list;
};

hrd.datatable.enumSelectAdapter = function (data, selected){
	var list = [];
	if(data){
		for ( var i = 0; i < data.aaData.length; i++) {
			var row = data.aaData[i];
			var item = {value: row.value, label: row.description};
			if(row.value == selected){
				item.selected = true;
			}
			list.push(item);
		}
	}
	return list;
};

/**
 * Utile per avere "id" oggetto riga ($tr) selezionata di tabella a selezione singola
 */
hrd.datatable.getSelectedRowId = function(tableId){
	var checkedRadio = $('input:radio:checked', tableId);
	return checkedRadio.exists() ? checkedRadio.val() : -1;
};

/**
 * Utile per avere oggetto riga ($tr) selezionata di tabella a selezione singola
 */
hrd.datatable.getSelectedRow = function(tableId){
	var $row = $('input:radio:checked', tableId).closest('tr');
	return $row;
};

hrd.datatable.getFirstRow = function(tableId){
	var $row = $('input:radio', tableId).first().closest('tr');
	return $row;
};

/**
 * Utile per avere oggetto riga ($tr) selezionata di tabella a selezione singola
 */
hrd.datatable.getRowById = function(rowId, tableId){
	var $row;
	if(rowId == undefined || tableId == undefined){
		$row = $('.non-existent-element'); // a valid jquery element, but really not present in page
	} else {
		$row = $('input[type="radio"][value="' + rowId + '"]', tableId).closest('tr');
	}
	return $row;
};

/**
 * Utile per avere id associato alla riga, data la riga ($tr)
 */
hrd.datatable.getIdByRow = function(nTr){
	var id = -1;
	var $radio = $('input[type="radio"]', nTr);
	if($radio.exists()){
		id = $radio.val();
	} else {
		var $check = $('input[type="checkbox"]', nTr);
		if($check.exists()){
			id = $check.val();
		}
	}
	return id;
};

/**
 * Utile per avere indice di una riga noto il suo id
 */
hrd.datatable.getRowIndexById = function(trId, tableId){
	var $row = $('tr[id="' + trId + '"]', tableId);
	return $row.data('row-index');
};

/**
 * Utile per avere tutte le righe che hanno un certo valore in una colonna specificata, accetta molte colonne
 */
hrd.datatable.getRowsByColumnValues = function(tableId, map){
	var aoData = $(tableId).dataTable().fnSettings().aoData;
	var candidates = $.grep(aoData, function(data){
		var flag = true;
		for(var column in map) {
			flag = flag && data._aData[column] == map[column];
		}
		return flag;
	})
	return $.map(candidates, function(data){
		return $(data.nTr);
	});
};

/**
 * Utile per avere oggetto json usato per popolare la riga selezionata di tabella a selezione singola
 */
hrd.datatable.getSelectedRowData = function(tableId){
	var oSettings = $(tableId).dataTable().fnSettings();
	var index = this.getSelectedRow(tableId).data('row-index');
	if(index != undefined){
		var rowData = $(tableId).dataTable().fnGetData(index - oSettings._iDisplayStart);
		return rowData;
	} else {
		return {};
	}
};

/**
 * select a row by id and scroll the table itself to make that row visible
 * Useful on for single-selection tables (with radio-button)
 */
hrd.datatable.selectTableRow = function(tableId, rowId, applyIgnoreCallback){
	var $row = this.getRowById(rowId, tableId);
	if($row.exists()){
		applyIgnoreCallback = applyIgnoreCallback == undefined ? true : applyIgnoreCallback;
		var oSettings = $(tableId).dataTable().fnSettings();
		if(oSettings && oSettings.oScroller && oSettings.oScroller.fnScrollToRow){
			var vis = $row.visibleInScroll(false);
			if(!vis.isVisible || !vis.isContained){
				oSettings.oScroller.fnScrollToRow($row.data('row-index'));
			}
		}
		if(applyIgnoreCallback){
			$row.data('ignore-callback', true);
		}
		$row.trigger('click', $row);
	}
};

/**
 * Select all the rows with given id, checking the correspondent check-box.
 * Useful for multi-selection tables (with check-box)
 */
hrd.datatable.selectTableRows = function(tableId, rowIds){
	if(rowIds && rowIds.length > 0){
		$('input:checkbox', tableId).each(function(i, row){
			var currentRowValue = $(row).val();
			var found = rowIds.find(function(value){
				return currentRowValue == value;
			})
			if(found !== undefined){
				$(row).prop('checked', true);
			}
		});
	}
};

hrd.datatable.checkTableRow = function(nRow, checked){
	$('input[type="checkbox"]', nRow).prop('checked', checked);
};

/**
 * Data una table, restituisce la promise dell'invocazione ajax usata per popolare la parte visibile
 */
hrd.datatable.getServerData = function(tableId){
	var $table = $(tableId).dataTable();
	var settings = $table.fnSettings();
	var aoData = $table._fnAjaxParameters();
	$table._fnServerParams(aoData);

	var promise = $.ajax( {
		"url":  settings.sAjaxSource,
		"data": aoData,
		"dataType": "json",
		"cache": false,
	});
	return promise;
};

/**
 * Data una table e un id di colonna (cioè il campo usato per referenziarla) restituisce indice di posizionamento della colonna stessa
 * Si può usare anche il valore dell'attributo 'sName' invece che 'mData', per recuperare colonne con bottone
 */
hrd.datatable.getColumnIndexById = function(tableId, colName){
	var $table = $(tableId).dataTable();
	var oSettings = $table.fnSettings();
	var index = -1;
	$.each(oSettings.aoColumns, function(i, val) {
		if(val.sName == colName || val.mData == colName) {
			index = i;
		}
	});
	return index;
};

/**
 * Data una table e un id di colonna (cioè il campo usato per referenziarla), mostra/nasconde la colonna stessa (toggle)
 */
hrd.datatable.toggleColumnVisibility = function(tableId, colName, visible, redraw) {
	var $table = $(tableId).dataTable();
	var iCol = this.getColumnIndexById(tableId, colName);

	var columns = $table.fnSettings().aoColumns;

	if(iCol >= 0 && iCol < columns.length){
		if(visible == undefined){
			visible = columns[iCol].bVisible;
		}
		$table.fnSetColumnVis(iCol, visible, redraw);
	}
};

/**
 * shortcut for ID cell (radio button cell)
 *
 */
hrd.datatable.createIdCellContent = function(prefix, id){
	var template = '<input type="radio" value="{id}" name="{prefix}-id" id="{prefix}-id-{id}" data-ignore="true">';
	return hrd.utils.replaceParams(template, {prefix: prefix, id: id});
};

/**
 * shortcut for ID cell (check-box  cell)
 *
 */
hrd.datatable.createCheckboxCellContent = function(prefix, id){
	var template= '<input type="checkbox" value="{id}" name="{prefix}-id" id="{prefix}-id-{id}" data-ignore="true">';
	return hrd.utils.replaceParams(template, {prefix: prefix, id: id});
};

/**
 * shortcut for generic check-box  cell
 *
 */
hrd.datatable.createGenericCheckboxCellContent = function(prefix, id, data, name){
	var template= '<input type="checkbox" value="{data}" name="{name}-{prefix}-id-{id}" id="{name}-{prefix}-id-{id}" data-ignore="true" class="generic-checkbox">';
	return hrd.utils.replaceParams(template, {prefix: prefix, id: id, data: data, name: name});
};

/**
 * shortcut for standard cell
 *
 * here this can be the table container reference object
 *
 */
hrd.datatable.createCellContent = function (prefix, id, text, formatStyle, ref, cellOptions){
	var template = undefined;
	text = hrd.datatable.formatCellData.call(this, text, formatStyle, cellOptions);
	if(ref != undefined){
		template = '<label for="{prefix}-id-{id}" class="table_cell_content" data-ref="{ref}">{text}</label>'
	} else {
		template = '<label for="{prefix}-id-{id}" class="table_cell_content">{text}</label>'
	}
	return hrd.utils.replaceParams(template, {prefix: prefix, id: id, text:text, ref: ref});
};

/**
 * shortcut for standard cell
 *
 * here this can be the table container reference object
 *
 */
hrd.datatable.createCellContentWithMarker = function (prefix, id, text, marker, formatStyle, ref, cellOptions){
	var template = undefined;
	text = hrd.datatable.formatCellData.call(this, text, formatStyle, cellOptions);
	if(ref != undefined){
		template = '<label for="{prefix}-id-{id}" class="table_cell_content {marker}" data-ref="{ref}">{text}</label>'
	} else {
		template = '<label for="{prefix}-id-{id}" class="table_cell_content {marker}">{text}</label>'
	}
	return hrd.utils.replaceParams(template, {prefix: prefix, id: id, text:text, marker: marker, ref: ref});
};

/**
 * shortcut for standard button cell
 *
 */
hrd.datatable.createButtonCellContent = function (prefix, id, name, options){
	var template;
	if(options){
		options = $.extend({
			btnClass: '',
			tooltip: '',
			style: undefined
		}, options);
		if(options.style != undefined){
			options.style = 'style="' + options.style + '"';
		} else {
			options.style = '';
		}
		template = '<button id="{prefix}-{name}-{id}" type="button" class="table-cell-button table-cell-button-{name} {btnClass}" {style} title="{tooltip}" data-reset="exclude"></button>';
		return hrd.utils.replaceParams(template, {id: id, name:name, prefix: prefix, btnClass: options.btnClass, tooltip: options.tooltip, style: options.style});
	} else {
		template = '<button id="{prefix}-{name}-{id}" type="button" class="table-cell-button table-cell-button-{name}" data-reset="exclude"></button>';
		return hrd.utils.replaceParams(template, {id: id, name:name, prefix: prefix});
	}
};

/**
 * shortcut for standard icon cell (without icon definition)
 *
 */
hrd.datatable.createIconCellContent = function (prefix, id, name, options){
	var template;
	if(options){
		options = $.extend({
			icon: '',
			tooltip: '',
			color: '#000000'
		}, options);
		template = '<span id="{prefix}-{name}-{id}" class="table-cell-icon f-icon {icon}" style="color:{color};" title="{tooltip}"></span>';
		return hrd.utils.replaceParams(template, {id: id, name:name, prefix: prefix, icon: options.icon, tooltip: options.tooltip, color: options.color});
	} else {
		template = '<span id="{prefix}-{name}-{id}" class="table-cell-icon f-icon" ></span>';
		return hrd.utils.replaceParams(template, {id: id, name:name, prefix: prefix});
	}
};

/**
 * shortcut for standard button cell
 *
 */
hrd.datatable.createEmptyCellContent = function (prefix, id, color){
	var template = '<label for="{prefix}-id-{id}" class="table_cell_content empty-column">&nbsp;</label>'
	return hrd.utils.replaceParams(template, {id: id, prefix: prefix});
};

hrd.datatable.createColoredCellContent = function (prefix, id, color, options) {
	options = $.extend({}, {
		defaultColor: undefined,
	}, options);
	color = hrd.utils.isNotEmpty(color) ? color : hrd.utils.isNotEmpty(options.defaultColor) ? options.defaultColor : '';
	var template = '<label for="{prefix}-id-{id}" class="table_cell_content color-column" style="background-color:{color};">&nbsp;</label>'
	return hrd.utils.replaceParams(template, {id: id, prefix: prefix, color: color});
};

hrd.datatable.createImageCellContent = function (prefix, rowData, options){
	var template;
	if(options.uid != undefined){
		template = '<label for="{prefix}-id-{id}" class="table_cell_content image-column {marker}"><div style="width:{width}px; height:{height}px;"><img class="table-thumbnail" src="download.do?uid={uid}&th={th}"/></div></label>';
	} else if(options.whenEmpty != undefined){
		options.initial = rowData[options.whenEmpty] ? rowData[options.whenEmpty].trim().substring(0,1).toUpperCase() : '';
		options.bgcolor = (options.color == undefined && options.fixedColor == undefined) ? '#ffffff' : (rowData[options.color] ? rowData[options.color] : (options.fixedColor) ? options.fixedColor : '#3366CC');
		options.fgcolor = $.colorHelper().computeTextColor(options.bgcolor);
		template = '<label for="{prefix}-id-{id}" class="table_cell_content image-column empty-image {marker}"><div style="width:{width}px; height:{height}px;background-color:{bgcolor};color:{fgcolor};">{initial}</div></label>';
	} else {
		template = '<label for="{prefix}-id-{id}" class="table_cell_content image-column {marker}"><div style="width:{width}px; height:{height}px;">&nbsp;</div></label>';
	}
	return hrd.utils.replaceParams(template, $.extend({}, {prefix: prefix, id: rowData.id}, options));
};

hrd.datatable.createFileCellContent = function (prefix, rowData, filePresent, options){
	var template;
	if(filePresent){
		template = '<button id="{prefix}-{name}-{id}" type="button" class="table-cell-button table-cell-button-{name} file-column {btnClass}" {style} title="{tooltip}"></button>';
	} else {
		template = '<label for="{prefix}-id-{id}" class="table_cell_content file-column">&nbsp;</div>'; // show nothing
	}
	return hrd.utils.replaceParams(template, $.extend({}, {prefix: prefix, id: rowData.id}, options));
};

hrd.datatable.createCustomCellContent = function (prefix, template, data, marker, options){
	if(options.useSpan === true){
		template = '<span class="table_cell_content {marker}">' + template + '</span>';
	} else {
		template = '<label for="{prefix}-id-{id}" class="table_cell_content {marker}">' + template + '</label>';
	}
	return hrd.utils.replaceParams(template, $.extend({}, {prefix: prefix, marker: marker}, data));
};

hrd.datatable.createInputCellContent = function (prefix, template, data, marker, options){
	throw 'createInputCellContent is not yet implemented';
};

hrd.datatable.createSelectCellContent = function (prefix, id, name, options){
	var template;
	options = options || {};
	if(options.skipEmptyOption){
		template = '<div class="field-composite"><select id="{prefix}-{name}-{id}" data-type="select1"></select></div>';
	} else {
		template = '<div class="field-composite"><select id="{prefix}-{name}-{id}" data-type="select1"><option value=""></option></select></div>';
	}
	return hrd.utils.replaceParams(template, {id: id, name:name, prefix: prefix});
};

/*
 * Here 'this' can be the container object in which this function is called...
 */
hrd.datatable.formatCellData = function(text, formatStyle, cellOptions){
	text = (text != undefined) ? ((typeof text.trim == 'function') ? text.trim() : text) : '';
	if(cellOptions != undefined){
		if(cellOptions.type){
			switch (cellOptions.type) {
			case 'duration':
				if(text != '' && text != '0'){
					var durationParse = cellOptions.durationParse || 'seconds';
					var pattern;
					var value = parseInt(text);
					if(cellOptions.patternFn !== undefined){
						if(typeof this[cellOptions.patternFn] == 'function'){
							pattern = this[cellOptions.patternFn].call(this);
						} else {
							pattern = 'hh:mm';
						}
					} else {
						pattern = cellOptions.pattern || 'hh:mm';
					}
					text = moment.duration(value, durationParse).format(pattern, {trim: false, useGrouping: false});
				}
				break;
			default:
				// do nothing
				break;
			}
		}
		if(cellOptions.escape != undefined){
			text = text.replace(/[<>]/g, function (c) {
				switch (c) {
				case '<': return '&lt;';
				case '>': return '&gt;';
				}
			});
		}
	}
	if(formatStyle && text && text !== ''){
		formatStyle = formatStyle || '';
		switch (formatStyle) {
		case '%':
		case '-%':
			text += '<span class="ignore"> %</span>'
			break;
		case '%-':
			text = '<span class="ignore">% </span>' + text;
			break;
		case '$':
		case '-$':
			text += ' <span class="ignore">' + hrd.globals.prefs.tenant.currencySymbol + '</span>';
			break;
		case '$-':
			text = '<span class="ignore">' + hrd.globals.prefs.tenant.currencySymbol + ' </span>' + text;
			break;
		case '$<-':
			text = '<span class="ignore" style="float:left">' + hrd.globals.prefs.tenant.currencySymbol + '</span>' + text;
			break;
		case '%<-':
			text = '<span  class="ignore" style="float:left">%</span>' + text;
			break;
		default:
			/// TODO: add 'ignore span'
			var hyphenPos = formatStyle.indexOf('-');
			if(hyphenPos == -1){
				text += ' ' + formatStyle;
			} else if(hyphenPos == 0){
				text += ' ' + formatStyle.substring(1);
			} else if(hyphenPos == formatStyle.length - 1){
				text = formatStyle.substring(0, hyphenPos) + ' ' + text;
			} else {
				var lasthyphenPos = formatStyle.lastIndexOf('-');
				if(lasthyphenPos == formatStyle.length - 1){
					text = formatStyle.substring(0, lasthyphenPos) + ' ' + text;
				} else {
					text += ' ' + formatStyle;
				}
			}
			break;
		}
	}
	if(formatStyle && formatStyle == '-' && hrd.utils.isEmpty(text)){
		text = '-';
	}
	return text;
};
